import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';

import SideMenu from '../containers/common/SideMenu';
import SettingsSubMenu from '../containers/common/SettingsSubMenu';


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <div className="sett__cont">
            <SettingsSubMenu />
            {children}
          </div>
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
